import styled from 'styled-components'
import { device } from '../Breakpoints'

const CTA = styled.div`
  position: fixed;
  z-index: 9999;
  bottom: 0;
  width: 100%;
  box-sizing: border-box;
  display: flex;
  background: linear-gradient(to right, #fa7272, #ffda76);
  padding: 0.8em 4em 0.8em 2em;
  justify-content: space-between;
  align-items: center;
  @media ${device.mobileL} {
    padding: 0.8em 1em;
    justify-content: flex-start;
  }
  svg,
  img {
    vertical-align: middle;
  }
  img {
    width: 2em;
    margin-right: 12px;
  }
  span {
    flex-grow: 2;
    font-size: 0.8em;
    color: #ffffff;
    font-family: 'Santral Light', Arial, Helvetica, sans-serif;
    @media ${device.mobileL} {
      display: none;
    }
  }
  a {
    flex-grow: 0;
    background-color: #ffffff;
    padding: 1.2em 4em;
    margin-right: 20px;
    border-radius: 50px;
    text-transform: uppercase;
    font-size: 0.6em;
    text-decoration: none;
    color: #ff8f8c;
    @media ${device.mobileL} {
      margin-right: 0px;
    }
  }
  button {
    flex-grow: 0;
    background: none;
    border: none;
    color: #ffffff;
    font-size: 1.2em;
    cursor: pointer;
  }
`
export default CTA
